import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadCampaigns () {
    const params = {
      limit: 20,
      offset: 0,
      is_archived: false
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/campaigns/', { params }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadConsumerOptions (campaign) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/campaigns/${campaign}/consumer/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
